export default "__VITE_ASSET__Drs367Kh__"